




































































import { Component, Vue, Prop } from "vue-property-decorator";
import QRCode from "qrcodejs2";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
@Component({
  components: { QRCode },
})
export default class Home extends Vue {
  public qrcodeBoxOne: any = null;
  public qrcodeBoxTwo: any = null;
  public qrcodeBoxThree: any = null;
  public qrcodeBoxSeven: any = null;
  public qrcodeBoxEight: any = null;
  @Prop({ type: String, default: "#FFAC1E" }) public titleColor;
  @Prop({ type: String, default: "index" }) public type;
  @Prop({ type: String, default: "" }) public qrcode;
  public theme = "light";
  public activeName = "1";
  public businessList = [
    {
      id: 1,
      cont: "传奇引擎合作",
      children: [
        // {
        //   index: 2,
        //   type: 1,
        //   avatar: require("@/assets/img/indexNew/avatar.png"),
        //   userName: "传奇商务小余",
        //   qqNumber: "QQ：2885654006",
        //   num: 2885654006,
        //   phoneNumber: "电话：13738005425",
        //   qrcodeId: "qrcodes7",
        //   qrcodeImg: require("@/assets/img/home/yu.png"),
        // },
        {
          index: 1,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传奇商务涂涂",
          qqNumber: "QQ：2881575411",
          num: 2881575411,
          phoneNumber: "电话：17815720079",
          qrcodeId: "qrcodes10",
          qrcodeImg: require("@/assets/img/home/tutu.jpg"),
        },
        {
          index: 2,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传奇商务麦芽",
          qqNumber: "QQ：2881957402",
          num: 2881957402,
          phoneNumber: "电话：18858422063",
          qrcodeId: "qrcodes7",
          qrcodeImg: require("@/assets/img/home/maiya.png"),
        },
        {
          index: 3,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传奇商务阿杜",
          qqNumber: "QQ：2881574772",
          num: 2881574772,
          phoneNumber: "电话：17717858732",
          qrcodeId: "qrcodes8",
          qrcodeImg: require("@/assets/img/home/du.png"),
        },
        {
          index: 4,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传奇商务七月",
          qqNumber: "QQ：2881575403",
          num: 2881575403,
          phoneNumber: "电话：18805607546",
          qrcodeId: "qrcodes9",
          qrcodeImg: require("@/assets/img/home/qi.png"),
        },
        {
          index: 5,
          type: 10,
          avatar: require("@/assets/img/indexNew/qq-group.png"),
          userName: "传奇引擎QQ交流群",
          qqNumber: "656631993（5群）",
          num: 758893644,
          qrcodeId: "qrcodesTwo",
          qrcodeImg: "",
        },
        // {
        //   index: 5,
        //   type: 4,
        //   avatar: require("@/assets/img/indexNew/qq-group.png"),
        //   userName: "传奇引擎lua交流群",
        //   qqNumber: "856211842",
        //   num: 856211842,
        //   qrcodeId: "qrcodesFive",
        //   qrcodeImg: "",
        // },
        {
          index: 6,
          type: 6,
          avatar: require("@/assets/img/indexNew/qq-group.png"),
          userName: "传奇引擎2.5D交流群",
          qqNumber: "577342074",
          num: 577342074,
          qrcodeId: "qrcodesSeven",
          qrcodeImg: "",
        },
        // {
        //   index: 7,
        //   type: 7,
        //   avatar: require("@/assets/img/indexNew/qq-group.png"),
        //   userName: "传奇引擎PC交流群",
        //   qqNumber: "1007963647",
        //   num: 1007963647,
        //   qrcodeId: "qrcodesEight",
        //   qrcodeImg: "",
        // },
      ]
    },
    {
      id: 2,
      cont: "传奇引擎纯PC版合作",
      children: [
        // {
        //   index: 2,
        //   type: 1,
        //   avatar: require("@/assets/img/indexNew/avatar.png"),
        //   userName: "传奇商务小余",
        //   qqNumber: "QQ：2885654006",
        //   num: 2885654006,
        //   phoneNumber: "电话：13738005425",
        //   qrcodeId: "qrcodes7",
        //   qrcodeImg: require("@/assets/img/home/yu.png"),
        // },
        {
          index: 1,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传奇商务涂涂",
          qqNumber: "QQ：2881575411",
          num: 2881575411,
          phoneNumber: "电话：17815720079",
          qrcodeId: "qrcodes10",
          qrcodeImg: require("@/assets/img/home/tutu.jpg"),
        },
        {
          index: 2,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传奇商务麦芽",
          qqNumber: "QQ：2881957402",
          num: 2881957402,
          phoneNumber: "电话：18858422063",
          qrcodeId: "qrcodes7",
          qrcodeImg: require("@/assets/img/home/maiya.png"),
        },
        {
          index: 3,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传奇商务阿杜",
          qqNumber: "QQ：2881574772",
          num: 2881574772,
          phoneNumber: "电话：17717858732",
          qrcodeId: "qrcodes8",
          qrcodeImg: require("@/assets/img/home/du.png"),
        },
        {
          index: 4,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传奇商务七月",
          qqNumber: "QQ：2881575403",
          num: 2881575403,
          phoneNumber: "电话：18805607546",
          qrcodeId: "qrcodes9",
          qrcodeImg: require("@/assets/img/home/qi.png"),
        },
        {
          index: 5,
          type: 7,
          avatar: require("@/assets/img/indexNew/qq-group.png"),
          userName: "传奇引擎纯PC版交流群",
          // qqNumber: "751346584",
          // num: 751346584,
          // qqNumber: "365640103",
          // num: 365640103,
          qqNumber: "693712440",
          num: 693712440,
          qrcodeId: "qrcodesEight",
          qrcodeImg: require("@/assets/img/home/chuanqi_pc4.png"),
        },
      ]
    },
    {
      id: 3,
      cont: "传世引擎合作",
      children: [
        {
          index: 1,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传世商务老史",
          qqNumber: "QQ：2881574773",
          num: 2881574773,
          phoneNumber: "电话：15897890902",
          qrcodeId: "qrcodes10",
          qrcodeImg: require("@/assets/img/home/shi.png"),
        },
        {
          index: 2,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传世商务桃花",
          qqNumber: "QQ：2881964490",
          num: 2881964490,
          phoneNumber: "电话：18964864298",
          qrcodeId: "qrcodes11",
          qrcodeImg: require("@/assets/img/home/tao.png"),
        },
        {
          index: 3,
          type: 3,
          avatar: require("@/assets/img/indexNew/qq-group.png"),
          userName: "传世引擎QQ交流群",
          qqNumber: "417640866(2群)",
          num: 417640866,
          qrcodeId: "qrcodesThree",
          qrcodeImg: "",
        },
      ]
    },
    {
      id: 4,
      cont: "传奇3引擎合作",
      children: [
        // {
        //   index: 2,
        //   type: 1,
        //   avatar: require("@/assets/img/indexNew/avatar.png"),
        //   userName: "传奇商务小余",
        //   qqNumber: "QQ：2885654006",
        //   num: 2885654006,
        //   phoneNumber: "电话：13738005425",
        //   qrcodeId: "qrcodes7",
        //   qrcodeImg: require("@/assets/img/home/yu.png"),
        // },
        {
          index: 1,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传奇商务涂涂",
          qqNumber: "QQ：2881575411",
          num: 2881575411,
          phoneNumber: "电话：17815720079",
          qrcodeId: "qrcodes10",
          qrcodeImg: require("@/assets/img/home/tutu.jpg"),
        },
        {
          index: 2,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传奇商务麦芽",
          qqNumber: "QQ：2881957402",
          num: 2881957402,
          phoneNumber: "电话：18858422063",
          qrcodeId: "qrcodes7",
          qrcodeImg: require("@/assets/img/home/maiya.png"),
        },
        {
          index: 3,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传奇商务阿杜",
          qqNumber: "QQ：2881574772",
          num: 2881574772,
          phoneNumber: "电话：17717858732",
          qrcodeId: "qrcodes8",
          qrcodeImg: require("@/assets/img/home/du.png"),
        },
        {
          index: 4,
          type: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "传奇商务七月",
          qqNumber: "QQ：2881575403",
          num: 2881575403,
          phoneNumber: "电话：18805607546",
          qrcodeId: "qrcodes9",
          qrcodeImg: require("@/assets/img/home/qi.png"),
        },
      ]
    },
    {
      id: 5,
      cont: "商务合作",
      children: [
        {
          index: 1,
          avatar: require("@/assets/img/indexNew/avatar.png"),
          userName: "合作邮箱",
          qqNumber: "bd@996m2.com",
        },
        {
          index: 100,
          userName: "微信公众号",
          gzhQRcode: require("@/assets/img/home/gzhQRcode.png"),
        },
      ]
    },
  ]
  public onSelect(name) {
    this.activeName = name;
  }

  public onCopy(e) {
    this.$Message.success("复制成功！");
  }
  public onError(e) {
    this.$Message.error("复制失败！");
  }
  public toAdd(state, num) {
    if (state == 1) {
      window.open(
        `http://wpa.qq.com/msgrd?v=3&uin=${num}&site=qq&menu=yes`,
        "_blank"
      );
    }
    if (state == 2) {
      window.open("https://jq.qq.com/?_wv=1027&k=H9YaAx4U", "_blank");
    }
    if (state == 3) {
      window.open("https://jq.qq.com/?_wv=1027&k=TVLGaHLU", "_blank");
    }
    if (state == 4) {
      window.open("https://jq.qq.com/?_wv=1027&k=1y6PeFe5", "_blank");
    }
    if (state == 5) {
      window.open("https://jq.qq.com/?_wv=1027&k=C36umHX3", "_blank");
    }
    if (state == 6) {
      window.open("https://jq.qq.com/?_wv=1027&k=hTB8Ij3O", "_blank");
    }
    if (state == 7) {
      window.open("http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=oIu8zCvHUSJSQQ-5nV9N_LwT2FieDyVy&authKey=LAOfiaA87E6VglgnSymRQb2veoIw2x4mQjy3YVmmFAsMxsM4672oLq4Bq2eZUc%2FE&noverify=0&group_code=365640103", "_blank");
    }
    if (state == 10) {
      window.open("https://jq.qq.com/?_wv=1027&k=nQouQVxP", "_blank");
    }
  }
  public mounted() {
    this.$nextTick(() => {
      this.qrcodes();
    });
  }
  public qrcodes() {
    // this.qrcodeBoxOne = new QRCode("qrcodesOne" + this.qrcode, {
    //   width: 100,
    //   height: 100, // 高度
    //   text: "http://wpa.qq.com/msgrd?v=3&uin=5285770&site=qq&menu=yes", // 二维码内容
    //   render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    // });
    this.qrcodeBoxTwo = new QRCode("qrcodesTwo", {
      width: 100,
      height: 100, // 高度
      text: "https://jq.qq.com/?_wv=1027&k=nQouQVxP", // 二维码内容
      render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    });
    this.qrcodeBoxThree = new QRCode("qrcodesThree", {
      width: 100,
      height: 100, // 高度
      text: "https://jq.qq.com/?_wv=1027&k=TVLGaHLU", // 二维码内容
      render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    });
    // this.qrcodeBoxThree = new QRCode("qrcodesFive", {
    //   width: 100,
    //   height: 100, // 高度
    //   text: "https://jq.qq.com/?_wv=1027&k=1y6PeFe5", // 二维码内容
    //   render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    // });
    // this.qrcodeBoxThree = new QRCode("qrcodesSix", {
    //   width: 100,
    //   height: 100, // 高度
    //   text: "https://jq.qq.com/?_wv=1027&k=C36umHX3", // 二维码内容
    //   render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    // });
    this.qrcodeBoxSeven = new QRCode("qrcodesSeven", {
      width: 100,
      height: 100, // 高度
      text: "https://jq.qq.com/?_wv=1027&k=hTB8Ij3O", // 二维码内容
      render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    });
    // this.qrcodeBoxEight = new QRCode("qrcodesEight", {
    //   width: 100,
    //   height: 100, // 高度
    //   text: "https://jq.qq.com/?_wv=1027&k=BYhNxk4my4k-eN7qOzistfGQ_ICR8X2_", // 二维码内容
    //   render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    // });
  }
}
